import React, { useState } from "react";
import FormattedMessage from "@irati/utils/lang";
import { H4 } from "@irati/ui/src/Typography";
import { Modal } from "../../Modal";
import ContentForm from "./Form";
import { SelectedTab } from "./types";
var EditTileModal = function (_a) {
    var companyNewsTile = _a.companyNewsTile, onClose = _a.onClose;
    var _b = useState(false), isPreview = _b[0], setPreview = _b[1];
    return (React.createElement(Modal, { header: React.createElement(H4, null,
            React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.editContent.title" })), onClose: onClose },
        React.createElement(ContentForm, { companyNewsTile: companyNewsTile, currentTab: SelectedTab.EDIT, onClose: onClose, isPreview: isPreview, setPreview: setPreview })));
};
export default EditTileModal;
